import { call, put, takeLatest } from "redux-saga/effects"
import axios from "axios"
import { push } from "connected-react-router"

import { GET_TEMPLATE_WATCHER, UPLOAD_TEMPLATE_WATCHER } from "./constants"

import {
  getTemplateSuccess,
  getTemplateFailed,
  uploadTemplateSuccess,
  uploadTemplateFailed,
} from "./actions"
import { LOCAL_TOKEN } from "../../utils/storage"

function messageProgress(messagex) {
  message.loading(messagex, 0)
}

function messageSuccess(messagex) {
  message.success(messagex, 5)
}

function messageFailed(messagex) {
  message.error(messagex, 5)
}

function messageDestroy() {
  message.destroy()
}

function getTemplateApi() {
  const measureId = localStorage.getItem("currentMeasure")
  const token = LOCAL_TOKEN()
  return axios.request({
    method: "get",
    headers: { Authorization: `Bearer ${token}` },
    url: `${process.env.API_URL}measure/${measureId}/recipients/export/xlsx/template`,
  })
}

function getTemplateApiProgress() {
  const measureId = localStorage.getItem("currentMeasure")
  const token = LOCAL_TOKEN()
  return axios.request({
    method: "get",
    headers: { Authorization: `Bearer ${token}` },
    url: `${process.env.API_URL}measure/${measureId}/recipients/export/xlsx/progress`,
  })
}

function downloadTemplate(url) {
  location.replace(url)
}

function getStatusExport(status) {
  return status
}

export function* getTemplateSaga(action) {
  try {
    yield call(messageProgress, "Descargando plantilla")
    yield call(getTemplateApi, action.payload)

    let data
    while (true) {
      yield new Promise((resolve) => setTimeout(resolve, 1000))
      data = yield call(getTemplateApiProgress)
      if (data.status === 200) break
    }

    yield call(downloadTemplate, data.data[0].url)
    yield call(messageDestroy)
    yield call(messageSuccess, getStatusExport("Plantilla descargada"))
    yield put(getTemplateSuccess())
  } catch (e) {
    yield call(messageDestroy)
    yield call(
      messageFailed,
      getStatusExport("Error al descargar la plantilla")
    )
    yield put(getTemplateFailed())
  }
}

// UPLOAD TEMPLATE
function uploadTemplate(payload) {
  const token = LOCAL_TOKEN()
  const measureId = localStorage.getItem("currentMeasure")
  return axios.request({
    method: "post",
    url: `${process.env.API_URL}measure/${measureId}/recipients/import/xlsx`,
    headers: { Authorization: `Bearer ${token}` },
    data: payload,
  })
}

function uploadTemplateProgress(payload) {
  const token = LOCAL_TOKEN()
  const measureId = localStorage.getItem("currentMeasure")
  return axios.request({
    method: "get",
    url: `${process.env.API_URL}measure/${measureId}/recipients/import/xlsx/progress`,
    headers: { Authorization: `Bearer ${token}` },
    params: payload,
  })
}

export function* uploadTemplateSaga(action) {
  try {
    yield call(messageProgress, "Cargando archivo")

    const uploadData = yield call(uploadTemplate, action.payload)
    const timestamp = { timestamp: uploadData.data.timestamp }
    const measureId = localStorage.getItem("currentMeasure")

    let data
    while (true) {
      yield new Promise((resolve) => setTimeout(resolve, 1000))

      data = yield call(uploadTemplateProgress, timestamp)

      if (data.status === 200) {
        yield put(uploadTemplateSuccess(data.data))
        yield call(messageDestroy)
        yield call(messageSuccess, "Archivo importado")
        yield put(
          push(
            `/models/measure/${measureId}/import-recipients/summary?time=${timestamp.timestamp}`
          )
        )
        break
      }
      if (data.status === 500) {
        yield call(messageDestroy)
        message.error(data.data.error, 5)
        yield put(uploadTemplateFailed())
        break
      }
    }
  } catch (e) {
    console.error("error", e)
    yield call(messageDestroy)
    yield call(messageFailed, "Error al importar el archivo")
    yield put(uploadTemplateFailed())
  }
}

export default function* getMeasurementRecipientsWatcherSaga() {
  yield takeLatest(GET_TEMPLATE_WATCHER, getTemplateSaga)
  yield takeLatest(UPLOAD_TEMPLATE_WATCHER, uploadTemplateSaga)
}
